import { g as n } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconMonitorOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function h(e, t, l, _, v, i) {
  return d(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--monitor-off"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Monitor Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M4 1.5a.5.5 0 0 1 .5-.5H10a1.5 1.5 0 0 1 1.5 1.5v5a.5.5 0 0 1-1 0v-5A.5.5 0 0 0 10 2H4.5a.5.5 0 0 1-.5-.5Zm-3.5 1v5A1.5 1.5 0 0 0 2 9h3.5v1H4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6.5V9h1.793l2.353 2.354a.5.5 0 0 0 .708-.708l-10-10a.5.5 0 1 0-.708.708l.145.144A1.741 1.741 0 0 0 .5 2.5Zm1.146 5.354A.5.5 0 0 0 2 8h5.293L1.534 2.241A.92.92 0 0 0 1.5 2.5v5a.5.5 0 0 0 .146.354Z" }, null, -1)
    ])], 8, m),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, c);
}
const A = /* @__PURE__ */ u(f, [["render", h]]);
export {
  A as default
};
//# sourceMappingURL=monitor-off.js.map
